import styled from 'styled-components';

export const Label = styled.tspan`
    fill: #182049;
    stroke: none;
    dominant-baseline: text-before-edge;
    font-size: 14px;
    text-anchor: middle;
`;
